<footer class="w-full lg:pb-5 pb-3 lg:px-5 px-3">
	<div class="py-0 px-4 text-left w-full max-w-full block m-auto">
		<p class="font-medium text-gray-400">&copy; {{ title }} {{ getYear() }}
      <a class="text-[color:var(--second-color)] hover:text-[color:var(--third-color)]" target="_blank" href="https://www.solunes.com/inicio"></a> |
        Todos los derechos reservados.</p>
	</div>
</footer>
